<template>
  <v-dialog
    v-model="show"
    max-width="650"
    class="add-note-modal"
    scrollable
    persistent
  >
    <v-card>
      <v-card-title>
        <h4 class="mb-1">{{ isEditMode ? 'Edit Note' : 'Add Note' }}</h4>
      </v-card-title>

      <v-divider class="mb-5" />

      <v-card-text class="my-3">
        <v-textarea
          v-model="form.content"
          :disabled="form.$busy"
          :error-messages="form.$getError('content')"
          :hide-details="!form.$getError('content')"
          label="Type note details here..."
          outlined
          flat
          rows="5"
        />
      </v-card-text>

      <v-divider class="mb-3" />

      <v-card-actions class="px-5 pb-5">
        <v-spacer />

        <v-btn
          color="primary"
          :loading="form.$busy"
          @click="close"
          outlined
          rounded
        >
          Cancel
        </v-btn>

        <v-btn
          color="secondary"
          :loading="form.$busy"
          :disabled="!form.content"
          @click="save"
          rounded
        >
          Save Note
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Form from '@/utils/form'
import { mapActions } from 'vuex'

export default {
  name: 'AddNoteDialog',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    note: {
      type: Object,
      default: null,
    },
    userId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      show: this.value,
      form: new Form({
        content: '',
      }),
    }
  },

  computed: {
    isEditMode() {
      return !!this.note
    },
  },

  methods: {
    ...mapActions({
      createNote: 'userProfile/createNote',
      updateNote: 'userProfile/updateNote',
    }),

    async save() {
      this.form.$busy = true
      this.form.$clearErrors()

      const action = this.isEditMode
        ? this.updateNote({
            userId: this.userId,
            noteId: this.note.id,
            content: this.form.content,
          })
        : this.createNote({
            userId: this.userId,
            content: this.form.content,
          })

      await action
        .then(() => {
          setTimeout(() => {
            this.form.$busy = false
            this.show = false
            this.$emit('saved')
          }, 600)
        })
        .catch(({ response }) => {
          setTimeout(() => {
            this.form.$busy = false

            if (response && response.status === 422) {
              this.form.$setErrors(response.data.errors)
            }
          }, 600)
        })
    },

    close() {
      this.show = false
    },
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)

      if (!val) {
        this.form.$clearErrors()
        this.form.content = ''
      }

      if (val && this.note) {
        this.form.content = this.note.content
      }
    },
  },
}
</script>
